import PropTypes from 'prop-types';
// @mui
import { Box } from '@mui/material';
// hooks
import { useResponsive} from '../../hooks';
// config
import { HEADER, NAV } from '../../config';
import { useSettingsContext } from '../../components/settings/context';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }) {
    const { themeLayout } = useSettingsContext();

    const isNavHorizontal = themeLayout === 'horizontal';

    const isNavMini = themeLayout === 'mini';

    const isDesktop = useResponsive('up', 'lg');

    if (isNavHorizontal) {
        return (
            <Box
                component="main"
                sx={{
                    pt: `${HEADER.MOBILE_HEIGHT + SPACING}px`,
                    pb: `${HEADER.MOBILE_HEIGHT + SPACING}px`,
                    ...(isDesktop && {
                        px: 2,
                        pt: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + 80}px`,
                        pb: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + SPACING}px`,
                    }),
                }}
            >
                {children}
            </Box>
        );
    }

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                py: `${HEADER.MOBILE_HEIGHT + SPACING}px`,
                ...(isDesktop && {
                    px: 2,
                    py: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + SPACING}px`,
                    width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
                    ...(isNavMini && {
                        width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
                    }),
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
}

Main.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node,
};
